{
  "moreActions": "기타 액션"
}
